import t from "../actions/PermissionActions/types";
import moment from 'moment'

const initialState = {
  menuList: [],
  userAccess: [],
  loading: false,
  permissionAccess: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case t.GET_MENULISTS:
      return {
          ...state,
          menuList: action.payload.body
      }
      // break;
    case t.GET_USERACCESS:
      return {
        ...state,
        userAccess:action.payload.body
      }

    case t.FETCH_PERMISSSION_REQUEST:
        return { 
                ...state, 
                loading: true, 
              };
    case t.FETCH_PERMISSSION_SUCCESS:
        return { 
                ...state, loading: false, 
                permissionAccess: action.payload.body 
              };
      default:
        return state;
    }
};